import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { useAuth } from "duck";
import { useGetOrganizationSettingsQuery } from "requests";
import { DateFormat, Temperature } from "./components";

const General: React.FC = () => {
  const [{ user }] = useAuth();
  const organizationId = user.organization?._id || 0;
  const { data } = useGetOrganizationSettingsQuery({
    variables: {
      _id: organizationId
    }
  });
  const settings = data?.organization?.organizationSetting;

  return (
    <>
      {settings ? (
        <Flex direction="column" rowGap={6}>
          <DateFormat settings={settings} />
          <Temperature settings={settings} />
        </Flex>
      ) : (
        <Flex justifyContent="center">
          <Spinner />
        </Flex>
      )}
    </>
  );
};

export default General;
